var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container account-page" },
    [
      _c("block-breadcrumbs", { attrs: { items: _vm.breadcrumbs } }),
      _c("page-head", { attrs: { title: "Личный кабинет" } }),
      _c("div", { staticClass: "wrapper" }, [
        _c("aside", [
          _c(
            "ul",
            _vm._l(_vm.nav, function(n, i) {
              return _c("li", { key: i }, [
                _c(
                  "a",
                  {
                    class: [
                      "nav-link",
                      "txt-overflow",
                      { active: n.path === _vm.$route.path }
                    ],
                    attrs: { href: n.path }
                  },
                  [
                    _vm._v(
                      "\n            " + _vm._s(n.name) + "\n            "
                    ),
                    _c("ui-badge", {
                      attrs: {
                        size: "large",
                        "max-width": "94",
                        text: n.badgeText,
                        color: n.badgeColor
                      }
                    }),
                    n.icon
                      ? _c("f-sprite-icon", { attrs: { "icon-link": n.icon } })
                      : _vm._e()
                  ],
                  1
                )
              ])
            }),
            0
          )
        ]),
        _c("div", { staticClass: "content" }, [_c("router-view")], 1)
      ]),
      _vm.isFavTabActive ? _c("product-gallery-recently-viewed") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }